import { AuthService } from '../../services/auth.service';
import { ConfigurationService } from '../../services/configuration.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LkLogoutRequiredEventHandler {
  constructor(
    private _authService: AuthService,
    private _configService: ConfigurationService
  ) {}

  public async handle(): Promise<void> {
    this._authService.signOut('', this._configService.user);
  }
}
